module.exports = __webpack_public_path__ + "static/beds-r-us-fdf3525bd2715cd578b515a75ee87fbc.webp";